import React from 'react';
import { MContentHeader } from '../../molecules/MContentHeader/index';
import { MContentHeaderAlignment } from '../../molecules/MContentHeader/MContentHeader.types';
import { MSlot } from '../../molecules/MSlot/index';
import { OMiniCardContainerProps } from './OMiniCardContainer.types';
import Styled from './OMiniCardContainer.styles';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OMiniCardContainer';
const TESTID = 'mi-web-ui-kit-OMiniCardContainer';

const EMPTY_AEM_REACT_COMPONENT_MAPPING = {};

export const OMiniCardContainer: React.FC<OMiniCardContainerProps> = ({
  desktopColumns = '3',
  mContentHeader,
  pagePath = '',
  itemPath = '',
  cqPath,
  isAuthorMode = false,
  aemReactComponentMapping = EMPTY_AEM_REACT_COMPONENT_MAPPING,
  className,
}) => {
  const columns = parseInt(desktopColumns, 10) || 3;

  return (
    <Styled.Container className={className} data-component-name={COMPONENT_NAME} data-testid={TESTID}>
      {mContentHeader && (
        <Styled.HeaderWrapper>
          {/*
           * OMiniCardContainer uses MContentHeaderProps directly, so mButton and
           * mContentSwap are already-mapped types. Resolution (flat vs. swap priority)
           * is handled inside MContentHeader.resolveContentSwapProps — this organism
           * intentionally does not call resolveRawButton. If you need flat-wins
           * semantics here, migrate mContentHeader to a raw organism-local type first.
           */}
          <MContentHeader
            alignment={mContentHeader.alignment || MContentHeaderAlignment.Left}
            mTextBlockSimple={mContentHeader.mTextBlockSimple}
            cta={mContentHeader.cta}
            mButton={mContentHeader.mButton}
            secondaryCta={mContentHeader.secondaryCta}
            mButton2={mContentHeader.mButton2}
            mContentSwap={mContentHeader.mContentSwap}
          />
        </Styled.HeaderWrapper>
      )}

      <Styled.CardsGrid $desktopColumns={columns}>
        <MSlot
          pagePath={pagePath}
          itemPath={itemPath ?? cqPath ?? ''}
          isAuthorMode={isAuthorMode}
          aemReactComponentMapping={aemReactComponentMapping}
        />
      </Styled.CardsGrid>
    </Styled.Container>
  );
};

export { OMiniCardContainer as default };
